/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.




  //display shipping date under add to cart

 
document.addEventListener("DOMContentLoaded", function () {
  var shippingInfoElement = document.getElementById("shipping-info");
  if (!shippingInfoElement) return;

  var shippingDateElement = document.getElementById("shipping-date");
  if (!shippingDateElement) return;

  var processingDays = parseInt(shippingInfoElement.getAttribute("data-processing-days"), 10);
  var productStatus = (shippingInfoElement.getAttribute("data-product-status") || "").trim();

  if (isNaN(processingDays) || processingDays <= 0) {
    shippingDateElement.innerText = "Error calculating date";
    return;
  }

  // If Liquid does not provide these, fallback to your fixed holiday range:
  var holidayStartStr = shippingInfoElement.getAttribute("data-holiday-start") || "2025-12-19";
  var holidayEndStr = shippingInfoElement.getAttribute("data-holiday-end") || "2026-01-12";

  function parseYMDToLocalDate(ymd) {
    var parts = String(ymd).split("-");
    return new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]), 0, 0, 0, 0);
  }

  function toYMD(date) {
    var y = date.getFullYear();
    var m = String(date.getMonth() + 1).padStart(2, "0");
    var d = String(date.getDate()).padStart(2, "0");
    return y + "-" + m + "-" + d;
  }

  function isWeekend(date) {
    return date.getDay() === 6 || date.getDay() === 0;
  }

  var publicHolidays = [
    "2025-01-01", "2025-01-26", "2025-04-18", "2025-04-21", "2025-04-25", "2025-12-25", "2025-12-26",
    "2026-01-01", "2026-01-26", "2026-04-03", "2026-04-06", "2026-04-25", "2026-12-25", "2026-12-26"
  ];

  function isPublicHoliday(date) {
    return publicHolidays.includes(toYMD(date));
  }

  var holidayStart = parseYMDToLocalDate(holidayStartStr);
  var holidayEnd = parseYMDToLocalDate(holidayEndStr);

  function isStudioHoliday(date) {
    var d = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0);
    return d >= holidayStart && d <= holidayEnd;
  }

  function isBlockedDay(date, excludeWeekendsAndPublicHolidays) {
    if (isStudioHoliday(date)) return true;
    if (excludeWeekendsAndPublicHolidays) {
      if (isWeekend(date)) return true;
      if (isPublicHoliday(date)) return true;
    }
    return false;
  }

  function getNextAvailableDate(startDate, daysToAdd, excludeWeekendsAndPublicHolidays) {
    var date = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate(), 0, 0, 0, 0);
    while (daysToAdd > 0) {
      date.setDate(date.getDate() + 1);
      if (!isBlockedDay(date, excludeWeekendsAndPublicHolidays)) {
        daysToAdd--;
      }
    }
    return date;
  }

  function nextBusinessDayAfterHolidayEnd() {
    var d = new Date(holidayEnd.getFullYear(), holidayEnd.getMonth(), holidayEnd.getDate(), 0, 0, 0, 0);
    d.setDate(d.getDate() + 1);
    while (isWeekend(d) || isPublicHoliday(d)) d.setDate(d.getDate() + 1);
    return d;
  }

  var today = new Date();
  today = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0, 0);

  var isWeekBased = (productStatus === "Made to order" || productStatus === "Bespoke order");
  var excludeWeekendsAndPublicHolidays = !isWeekBased;

  var startDate = today;
  if (isStudioHoliday(today)) {
    startDate = nextBusinessDayAfterHolidayEnd();
  }

  var estimatedDate = getNextAvailableDate(startDate, processingDays, excludeWeekendsAndPublicHolidays);

  var formattedDate = estimatedDate.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric"
  });

  shippingDateElement.innerText = formattedDate;
});
})();
